import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { FleetCategoryLink } from '@/components/FleetCategory/FleetCategoryLink';
import { Carousel } from '@/components/carousel/Carousel';
import { CarouselSlide } from '@/components/carousel/CarouselSlide';
import { breakpointUtils } from '@/lib/breakpoints';
import { mapFleetCategoryCarouselImages } from '@/lib/mapFleetCategoryCarouselImages';
import type { CmsFleetCategory } from '@/services/cms-sdk/';
type FleetTypeCardImagesCarouselProps = {
  className?: string;
  fleetCategory: CmsFleetCategory;
  height?: number;
  preload?: boolean;
  width?: number;
};
export function FleetTypeCardImagesCarousel(t0) {
  const $ = _c(7);
  const {
    className,
    fleetCategory,
    height: t1,
    preload,
    width: t2
  } = t0;
  const height = t1 === undefined ? 150 : t1;
  const width = t2 === undefined ? 244 : t2;
  let t3;
  if ($[0] !== className || $[1] !== fleetCategory || $[2] !== height || $[3] !== preload || $[4] !== width) {
    const allImages = mapFleetCategoryCarouselImages(fleetCategory);
    const {
      up
    } = breakpointUtils;
    const sizes = `
      ${up("md")} 414px,
      ${up("sm")} 345px,
      325px
    `;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        slidesToScroll: 1,
        containScroll: "trimSnaps",
        skipSnaps: true
      };
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = <Carousel className="[--carousel-spacing:0] mb-0" spacing={0} options={t4} showNavigation={true} showPagination={true} navClassName="[.left-0&]:ml-[2%] [.right-0&]:mr-[2%]" paginationClassName="absolute bottom-2" paginationColor="white">{allImages.map((imageData, index) => {
        const trimmedUrl = imageData.src.trim();
        return <CarouselSlide as="div" key={trimmedUrl.slice(-10, -1) + index} className="w-full h-full"><FleetCategoryLink fleetCategory={fleetCategory}><Image src={trimmedUrl} alt={imageData.alt} width={width} height={height} className={className} preload={preload && index === 0 ? true : undefined} fetchPriority={preload && index === 0 ? "high" : undefined} sizes={sizes} /></FleetCategoryLink></CarouselSlide>;
      })}</Carousel>;
    $[0] = className;
    $[1] = fleetCategory;
    $[2] = height;
    $[3] = preload;
    $[4] = width;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}